// extracted by mini-css-extract-plugin
module.exports = {"Intro":"portfolios_Intro__iMwU9","Grid":"portfolios_Grid__FbYti","Card":"portfolios_Card__jbTpg"};